"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uuid = _interopRequireDefault(require("uuid"));
var _getters = _interopRequireDefault(require("./getters"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _headerDefaults = {};
var _bodyDefaults = {
  subject: '',
  subTopic: '',
  source: '',
  value: ''
};
function getBaseHeader(topic) {
  return _objectSpread({
    id: _uuid["default"].v4(),
    timestamp: new Date().toISOString(),
    topic: topic,
    sourceSystem: process.env.ANALYTICS_APP_NAME + '_' + process.env.LOB
  }, _headerDefaults);
}
function getBaseBody() {
  return _objectSpread(_objectSpread({
    appName: _getters["default"].appName,
    url: window.location.href,
    sessionId: _getters["default"].sessionId
  }, _getters["default"].client), _bodyDefaults);
}
var _default = exports["default"] = {
  extendHeaderDefaults: function extendHeaderDefaults(defaults) {
    _headerDefaults = _objectSpread(_objectSpread({}, _headerDefaults), defaults);
  },
  extendBodyDefaults: function extendBodyDefaults(defaults) {
    _bodyDefaults = _objectSpread(_objectSpread({}, _bodyDefaults), defaults);
  },
  compose: function compose(topic, body) {
    return {
      header: getBaseHeader(topic),
      body: _objectSpread(_objectSpread({}, getBaseBody()), body)
    };
  }
}; // to be passed in on request or as 'default'
// source: navService.getInstrumentationId(),
// emailHandoffType